<script setup lang="ts">
import deviceApi from "@/deviceApi";
import AudioAlert from './components/AudioAlert.vue';
</script>

<template>
  <RouterView>
  </RouterView>
  <audio-alert v-if="!deviceApi.isApp()"/>
</template>

<style scoped>
#background-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>
